// @ts-nocheck
import {
    chain,
    PopulateApiParameter,
} from "@insite/client-framework/Store/Components/ContactUsForm/Handlers/SubmitContactForm";
import translate from "@insite/client-framework/Translate";
import { addToChainAfter, createChainHandler } from "@toolkit/Modules/client-framework/HandlerCreator";
import { contactUsAvailableTopics } from "@store/Overrides/Widgets/ContactUs/AvailableTopics";

export const PopulateAdditionalApiParameter = createChainHandler("PopulateAdditionalApiParameter", chain, props => {
    const state = props.getState().components.contactUsForm;
    const greifState = props.getState().greif.pages.contactUs;
    const selectedTopic = state.fieldValues["topic"];
    const topicTranslationKey = Object.values(contactUsAvailableTopics).find(
        topic => topic.value === selectedTopic,
    )?.label;
    const translatedTopic = topicTranslationKey ? translate(`${topicTranslationKey}`) : selectedTopic;

    props.apiParameter = {
        ...props.apiParameter,
        topic: translatedTopic,
        properties: {
            userCompany: state.fieldValues["userCompany"],
            jobTitle: state.fieldValues["jobTitle"] || undefined,
            userSelectedPlant: greifState.plantFieldValues.plantDisplayName,
            customerServiceRepresentativeEmail: greifState.plantFieldValues.email,
            shipTo: greifState.shipTo || greifState.customerNumber || undefined,
            soldTo: greifState.soldTo || undefined,
        },
    };
});

addToChainAfter(chain, PopulateApiParameter, PopulateAdditionalApiParameter);
